<h3>{{ this.experience.isCustomTitle ? this.experience.customTitle : displayTitle(this.experience.experience.titles, this.itinerary?.tour?.language) }}</h3>
<div class=" mt-3 mb-5 grid grid-cols-1 gap-4">
  <div *ngIf="this.experience.featuredExperience?.image" class="mb-3">
    <img class="object-cover rounded-2xl h-64 w-full mt-2"
         [src]=this.experience.featuredExperience?.image
         alt="{{this.experience.experience.area }}">
  </div>
  <div class="mb-3">
    <h5>{{ this.experience.featuredExperience?.keyword }}</h5>
    <p [innerHTML]="this.experience.featuredExperience?.body"></p>
  </div>

  <!-- Free layout -->
  <ng-container *ngIf="experience?.costType === SETTINGS.COST_TYPES_EXPERIENCES[0].value">
    <div>
      <h5>{{ 'itineraries.viewContentModal.experiences.pax' | transloco }}</h5>
      <div class="flex">
        <nz-tag [nzColor]="'purple'">{{ this.pax?.adults }} {{ 'itineraries.viewContentModal.common.adults' | transloco }}</nz-tag>
        <nz-tag [nzColor]="'purple'">{{ this.pax?.children }} {{ 'itineraries.viewContentModal.common.children' | transloco }}</nz-tag>
        <nz-tag [nzColor]="'purple'">{{ this.pax?.infants }} {{ 'itineraries.viewContentModal.common.infants' | transloco }}</nz-tag>
      </div>
    </div>
  </ng-container>

  <!-- Per Person layout -->
  <ng-container *ngIf="experience?.costType === SETTINGS.COST_TYPES_EXPERIENCES[1].value">
    <div>
      <h5>{{ 'itineraries.viewContentModal.experiences.pax' | transloco }}</h5>
      <div class="flex">
        <nz-tag [nzColor]="'purple'"
        >{{ this.pax?.adults }} {{ 'itineraries.viewContentModal.common.adults' | transloco }}
        </nz-tag
        >
        <nz-tag [nzColor]="'purple'"
        >{{ this.pax?.children }} {{ 'itineraries.viewContentModal.common.children' | transloco }}
        </nz-tag
        >
        <nz-tag [nzColor]="'purple'"
        >{{ this.pax?.infants }} {{ 'itineraries.viewContentModal.common.infants' | transloco }}
        </nz-tag
        >
      </div>
    </div>
    <div class="grid md:grid-cols-3 grid-cols-1">
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.costPerAdult' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{
              (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
              (this.experience.costPerAdult | number: '1.2-2')
            }}
          </nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.costPerChild' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{
              (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
              (this.experience.costPerChild | number: '1.2-2')
            }}
          </nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.costPerInfant' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{
              (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
              (this.experience.costPerInfant | number: '1.2-2')
            }}
          </nz-tag>
        </div>
      </div>
    </div>
    <div class="grid md:grid-cols-3 grid-cols-1 mb-3">
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.markupType' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{ getMarkupTypeLabel() }}
          </nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.markupRate' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{ experience.costing?.markupSymbol === SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT
              ? (experience.costing?.markupRatio | number: '1.2-2') + '%'
              : (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' + (experience.costing?.markupRatio | number: '1.2-2') }}
          </nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.markupCost' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{ (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' + (this.experience.costing?.markup | number: '1.2-2') }}
          </nz-tag>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <h5>{{ 'itineraries.viewContentModal.experiences.totalCost' | transloco }}</h5>
      <div>
        <nz-tag [nzColor]="'purple'">
          {{
            (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
            (this.totalCost | number: '1.2-2')
          }}
        </nz-tag>
      </div>
    </div>
  </ng-container>

  <!-- Per Group layout -->
  <ng-container *ngIf="experience?.costType === SETTINGS.COST_TYPES_EXPERIENCES[2].value">
    <div class="mb-3">
      <h5>{{ 'itineraries.viewContentModal.experiences.perGroup' | transloco }}</h5>
      <div class="flex gap-2 mt-1">
        <nz-tag [nzColor]="'purple'">{{ this.pax?.adults }} {{ 'itineraries.viewContentModal.common.adults' | transloco }}</nz-tag>
        <nz-tag [nzColor]="'purple'">{{ this.pax?.children }} {{ 'itineraries.viewContentModal.common.children' | transloco }}</nz-tag>
        <nz-tag [nzColor]="'purple'">{{ this.pax?.infants }} {{ 'itineraries.viewContentModal.common.infants' | transloco }}</nz-tag>
      </div>
    </div>

    <div class="grid md:grid-cols-3 grid-cols-1 mb-3">
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.cost' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{
              (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
              (this.experience.costing?.cost | number: '1.2-2')
            }}
          </nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.maximumPax' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">{{ this.experience.costing?.maximumPax }}</nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.quantity' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">{{ this.experience.costing?.quantity }}</nz-tag>
        </div>
      </div>
    </div>

    <div class="mb-3" *ngIf="this.experience.advancedOptions?.isChecked">
      <h5>{{ 'itineraries.viewContentModal.experiences.advancedOptions' | transloco }}</h5>
      <div class="grid md:grid-cols-3 grid-cols-1 mt-2">
        <div class="mb-3">
          <h5>{{ 'itineraries.viewContentModal.experiences.includedPax' | transloco }}</h5>
          <div>
            <nz-tag [nzColor]="'purple'">{{ this.experience.advancedOptions?.includedPax }}</nz-tag>
          </div>
        </div>
        <div class="mb-3">
          <h5>{{ 'itineraries.viewContentModal.experiences.extraPaxCost' | transloco }}</h5>
          <div>
            <nz-tag [nzColor]="'purple'">
              {{
                (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
                (this.experience.advancedOptions?.extraPaxCost | number: '1.2-2')
              }}
            </nz-tag>
          </div>
        </div>
      </div>
    </div>

    <div class="grid md:grid-cols-3 grid-cols-1 mb-3">
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.markupType' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{ getMarkupTypeLabel() }}
          </nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.markupRate' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{ experience.costing?.markupSymbol === SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT
              ? (experience.costing?.markupRatio | number: '1.2-2') + '%'
              : (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' + (experience.costing?.markupRatio | number: '1.2-2') }}
          </nz-tag>
        </div>
      </div>
      <div class="mb-3">
        <h5>{{ 'itineraries.viewContentModal.experiences.markupCost' | transloco }}</h5>
        <div>
          <nz-tag [nzColor]="'purple'">
            {{ (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' + (this.experience.costing?.markup | number: '1.2-2') }}
          </nz-tag>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <h5>{{ 'itineraries.viewContentModal.experiences.totalCost' | transloco }}</h5>
      <div>
        <nz-tag [nzColor]="'purple'">
          {{
            (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
            (this.experience.costing?.totalCost | number: '1.2-2')
          }}
        </nz-tag>
      </div>
    </div>
  </ng-container>
</div>
<div class="mb-5">
  <h5 class="mb-3">{{ 'itineraries.viewContentModal.experiences.conditionType' | transloco }}</h5>
    <ng-container *ngIf="getConditionBadge(this.experience?.conditionType) as badge">
      <span [ngClass]="badge.classes">
        {{ badge.label }}
      </span>
    </ng-container>
</div>
<div class="mb-5">
  <h5>{{ 'itineraries.viewContentModal.experiences.url' | transloco }}</h5>
  <div class="grid grid-cols-1">
    <div>
      <nz-tag class="whitespace-normal break-all" [nzColor]="'purple'"> {{ this.experience?.customUrl ? this.experience?.customUrl : getEmptyValue()  }}</nz-tag>
    </div>
  </div>
</div>
<div class="grid grid-cols-2 gap-4 mb-5">
  <div>
    <h5>{{ 'itineraries.viewContentModal.experiences.selectedDays' | transloco }}</h5>
    <div class="flex flex-wrap gap-2">
      <nz-tag [nzColor]="'purple'" *ngFor="let date of this.selectedExperiences; let i = index">
        {{!this.itinerary.tour.isDatesOptional ? (date | date:'dd/MM/yyyy'): ('itineraries.viewContentModal.common.dayLabel' | transloco:{ day: date + 1 })}}
      </nz-tag>
    </div>
  </div>
  <div *ngIf="this.experience?.time">
    <h5>{{ 'itineraries.viewContentModal.experiences.selectedTime' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">{{ this.experience.time }}</nz-tag>
    </div>
  </div>
</div>
<div>
  <h5>{{ 'itineraries.viewContentModal.common.notes' | transloco }}</h5>
  <div class="grid grid-cols-1">
    <div>
      <nz-tag class="whitespace-normal break-all" [nzColor]="'purple'"> {{ this.experience.notes }}</nz-tag>
    </div>
  </div>
</div>
